
import { Component, InjectReactive, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

// sub-components specific application modules
import ResetButton from '@/components/buttons/ResetButton.vue';
import FilterAgeCertification from '@/components/filter-bar/FilterAgeCertification.vue';
import FilterBarGenres from '@/components/filter-bar/FilterBarGenres.vue';
import FilterMonetizationTypes from '@/components/filter-bar/FilterMonetizationTypes.vue';
import FilterPresentationTypes from '@/components/filter-bar/FilterPresentationTypes.vue';
import FilterPrice from '@/components/filter-bar/FilterPrice.vue';
import FilterRating from '@/components/filter-bar/FilterRating.vue';
import FilterReleaseYear from '@/components/filter-bar/FilterReleaseYear.vue';
import ChipButton from '@/ui-components/ChipButton.vue';
import ChipButtons from '@/ui-components/ChipButtons.vue';

import { CollectionType } from '@/enums/collection-type';

import { FilterValues, getUsedFilters, isAnyFilterActive } from '@/helpers/filter-helper';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

import { AgeCertifications, AgeCertificationsConstant } from '@/stores/constant.store';
import { FilterCollection } from '@/stores/filter.store';

const Filter = namespace('filter');

const filterValues = { ...FilterValues };

@Component({
	components: {
		ChipButton,
		ChipButtons,
		FilterAgeCertification,
		FilterBarGenres,
		FilterPrice,
		FilterReleaseYear,
		FilterMonetizationTypes,
		FilterPresentationTypes,
		FilterRating,
		ResetButton,
	},
})
export default class FilterButton extends Vue {
	@Prop() collectionType: CollectionType;

	@Filter.Getter filters: (collectionType: CollectionType) => FilterCollection;

	@InjectReactive(AgeCertificationsConstant) ageCertifications: AgeCertifications;

	get currentFilters() {
		return this.filters(this.collectionType);
	}

	get filterValues() {
		if (!this.ageCertifications.hasCertifications) {
			delete filterValues['FilterAgeCertification'];
		}
		return filterValues;
	}

	get hasActiveFilter() {
		const usedFilters = getUsedFilters(this.filterValues);
		return isAnyFilterActive(usedFilters, this.currentFilters);
	}

	async openFilterBarMenu(): Promise<void> {
		const { menuController } = await import('@/ionic.loader');

		menuController.open('filters');
		TrackingHelper.trackEvent('userinteraction', {
			action: 'filters_opened',
		});
	}
}
